import { InvoicePayment } from '../../invoice-payment/invoice-payment.model';
import { AdjustmentDto } from '../../../../invoices/dto/adjustment.dto';
import { PaymentSource } from '../../payment-source/payment-source.model';
import { PaymentTypeDto } from '../../payment-types/dto/payment-type.dto';
export interface UnappliedPaymentDto {
  UnappliedPaymentId: number;
  InvoiceNumber: number;
  ProfileId: number;
  AppliedToPaymentId: number;
  PaymentDate: Date;
  ApplyDate: Date;
  PaymentTypeId: number;
  PaymentType: string;
  Amount: number;
  Refno: string;
  CheckNum: string;
  Notes: string;
  DateCreated: Date;
  DateChanged: Date;
  ChangedBy: string;
  Posted: boolean;
  DatePosted: Date;
  Batch_Creation: string;
  Batch_Posting: string;
  PaymentSource: string;
  CC_CreditCardNum: string;
  CC_ValidThrough: string;
  CC_NameOnCard: string;
  CC_BillingAddress1: string;
  CC_BillingAddress2: string;
  CC_BillingCity: string;
  CC_BillingState: string;
  CC_BillingZip: string;
  CC_BillingZipExt: string;
  CC_Pin: string;
  CC_PhoneNum: string;
  PostedBy: string;
  AdjustedAmount: number;

  Adjustments: AdjustmentDto[];
  PaymentType1: PaymentTypeDto;

  // view-only properties
  _paymentType: PaymentTypeDto;
  _paymentSource: PaymentSource;
}

export function initializedUnappliedPaymentDto(partialDto?: Partial<UnappliedPaymentDto>) {
  const today = new Date();
  const defaultDto = {
    ProfileId: 0,
    PaymentDate: today,
    ApplyDate: today,
    PaymentTypeId: 0,
    Amount: 0,
    DateCreated: today,
    DateChanged: today,
    Posted: false,
    DatePosted: today,

    _paymentType: null,
    _paymentSource: null,
  } as UnappliedPaymentDto;

  return { ...defaultDto, ...(partialDto ?? {}) };
}
